import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      className='container-fluid d-flex align-items-center justify-content-center vh-100'
      style={{ overflow: 'hidden' }}
    >
      <div
        className='text-center position-relative'
        style={{ zIndex: 1, maxWidth: '500px' }}
      >
        {/* Background Decorative Element */}
        <div
          className='position-absolute top-50 start-50 translate-middle'
          style={{
            width: '400px',
            height: '400px',
            background:
              'radial-gradient(circle, rgba(var(--bs-primary-rgb), 0.05) 0%, transparent 70%)',
            zIndex: -1,
          }}
        ></div>

        {/* 404 Heading */}
        <h1
          className='fw-black text-primary mb-0'
          style={{
            fontSize: '10rem',
            lineHeight: 1,
            opacity: 0.1,
            fontWeight: 900,
            letterSpacing: '-5px',
          }}
        >
          404
        </h1>

        <div
          className='mt-n5 position-relative'
          style={{ marginTop: '-4rem' }}
        >
          <div
            className='bg-primary bg-opacity-10 d-inline-flex align-items-center justify-content-center rounded-circle mb-4 shadow-sm'
            style={{ width: '100px', height: '100px' }}
          >
            <i className='bi bi-search text-primary fs-1 animate-float'></i>
          </div>

          <h2 className='h3 fw-bold text-dark mb-3'>Halaman Tidak Ditemukan</h2>
          <p className='text-muted mb-5 px-4'>
            Maaf, halaman yang Anda cari tidak dapat ditemukan atau telah
            dipindahkan.
          </p>

          <div className='d-flex flex-column flex-sm-row gap-3 justify-content-center'>
            <button
              onClick={() => navigate(-1)}
              className='btn btn-light border-light-subtle px-4 py-2 rounded-pill fw-bold d-flex align-items-center justify-content-center gap-2 transition-all hover-scale'
            >
              <i className='bi bi-arrow-left'></i>
              Kembali
            </button>
            <button
              onClick={() => navigate('/')}
              className='btn btn-primary px-4 py-2 rounded-pill fw-bold d-flex align-items-center justify-content-center gap-2 transition-all hover-scale'
            >
              <i className='bi bi-house-door'></i>
              Ke Beranda
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .fw-black { font-weight: 900; }
        .hover-scale:hover { transform: scale(1.05); }
        .transition-all { transition: all 0.2s ease; }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0px); }
        }
      `}</style>
    </div>
  );
};

export default NotFound;
